import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../../modules/infra/i18n';
import { formValues } from 'redux-form';
import Input from '../../../common/input';

const ShopCode = ({ adpReport }) => (
  <div className="layout__item" display-if={adpReport}>
    <div className="c-label c-label--light">{t('admin:shop_code.label')}</div>
    <Input className="c-input" name="adpCoCode" type="text" placeholder={t('admin:shop_code.placeholder')} />
  </div>
);

ShopCode.propTypes = {
  adpReport: PropTypes.bool.isRequired,
};

export default formValues('adpReport')(ShopCode);
